import { inject } from "vue";

export default function manipulatePaginatorSearch() {
    
    let inputs = inject("inputs");
    
    return { inputs };
}